export default __webpack_public_path__ + "static/background-night-720740a6cd222232dd45267c24abab64.png";